<template>
  <div class="reviews">
    <div class="grid">
      <div
        v-for="(review, index) in computedObj"
        :key="`review-item-${index}`"
        class="grid-item"
      >
        <div class="review-item">
          <div class="review-item-element">
            <h4> {{ review.title }}</h4>
          </div>
          <template
            v-if="hasSubtitle(review)"
          >
          <div class="review-item-element">
            <h5> {{ review.subtitle }}</h5>
          </div>
          </template>
          <div class="review-item-element">
            <read-more
              v-if="review.review"
              :text="review.review"
              :max-chars="140"
              class="item-description"
            />
          </div>
          <template
            v-if="hasRating(review)"
          >
          <div class="review-item-element">
            Rating: {{ review.points }}
          </div>
          </template>
        </div>
      </div>
    </div>
    <template v-if="hasLimit">
      <div class="show-more">
        <HighlightButton
          button-type="rounded"
          button-style="outline"
          button-size="small"
          title="Show More"
          @click.native="showMore()"
        />
      </div>
    </template>
  </div>
</template>

<script>
import ReadMore from '../../ReadMore.vue'

export default {
  name: 'reviews',
  components: {
    ReadMore
  },
  props: {
    content: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      limit: 2
    }
  },
  computed: {
    hasLimit() {
      return this.limit != null && this.content.length > this.limit
    },
    computedObj() {
      return this.limit ? this.content.slice(0, this.limit) : this.content
    }
  },
  methods: {
    showMore() {
      return this.limit = null
    },
    hasSubtitle(review) {
      return [undefined, null, ''].indexOf(review.subtitle) === -1
    },
    hasRating(review) {
      return [undefined, null, ''].indexOf(review.points) === -1
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@scss/custom.scss";

.grid {
  --col-size: 1;

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(48%, 1fr));
  grid-gap: 1.5em;
  gap:1.5em;

  @include media-breakpoint-up(lg) { --col-size: 2; }

  .grid-item {
    grid-column: span 1;
    display: flex;
    flex-direction: column;
  }
}

//show more position
.show-more {
  margin-top: 1.5em;
  display: flex;
  justify-content: center;
}

//styling specific to the item content
.review-item {
  height: 100%;
}

.review-item-element {
  margin-bottom:.5em;
}

//inline read more link
.item-description {
 ::v-deep p {
    &:last-of-type {
      display: inline;
      margin-bottom: 0;
    }
  }
}
</style>
